var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreview1241(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1012_82735)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    width: 11,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51562 15H5.30859V11.6953C5.30859 11.6042 5.3099 11.4922 5.3125 11.3594C5.3151 11.224 5.31901 11.0859 5.32422 10.9453C5.32943 10.8021 5.33464 10.6732 5.33984 10.5586C5.3112 10.5924 5.2526 10.651 5.16406 10.7344C5.07812 10.8151 4.9974 10.888 4.92188 10.9531L4.26562 11.4805L3.68359 10.7539L5.52344 9.28906H6.51562V15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5234 15H16.5312V14.1602L17.9648 12.7109C18.2539 12.4141 18.4857 12.1667 18.6602 11.9688C18.8372 11.7682 18.9648 11.5859 19.043 11.4219C19.1237 11.2578 19.1641 11.082 19.1641 10.8945C19.1641 10.668 19.1003 10.4987 18.9727 10.3867C18.8477 10.2721 18.6797 10.2148 18.4688 10.2148C18.2474 10.2148 18.0326 10.2656 17.8242 10.3672C17.6159 10.4688 17.3984 10.6133 17.1719 10.8008L16.5156 10.0234C16.6797 9.88281 16.8529 9.75 17.0352 9.625C17.2201 9.5 17.4336 9.39974 17.6758 9.32422C17.9206 9.24609 18.2135 9.20703 18.5547 9.20703C18.9297 9.20703 19.2513 9.27474 19.5195 9.41016C19.7904 9.54557 19.9987 9.73047 20.1445 9.96484C20.2904 10.1966 20.3633 10.4596 20.3633 10.7539C20.3633 11.069 20.3008 11.3568 20.1758 11.6172C20.0508 11.8776 19.8685 12.1354 19.6289 12.3906C19.3919 12.6458 19.1055 12.9284 18.7695 13.2383L18.0352 13.9297V13.9844H20.5234V15Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1012_82735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview1241);
export default __webpack_public_path__ + "static/media/Preview124-1.5bef5050dadbc3607f027a7c37241a42.svg";
export { ForwardRef as ReactComponent };